jQuery(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });
 
  setTimeout(function(){
   
  $(".t4s-lookbook-pin").trigger("click");
  $(".t4s-lookbook-pin:last").trigger("click");
    $('.custom-prev-btn').click(function () {

        var pid = $(this).parent().parent().parent().attr('id');
        var bid = $('span[data-bid="' + pid + '"]');
        var lastbid = $(bid).prev().prev().length > 0;
        if (lastbid) {
            $(bid).prev().prev().trigger("click");
        }
        else {
            $('.t4s-pr.t4s-lookbook-wrapper').find(">span:last").trigger("click");
        }
    });

    $('.custom-next-btn').click(function () {

        var pidn = $(this).parent().parent().parent().attr('id');
        var bidn = $('span[data-bid="' + pidn + '"]');
        var firstbid = $(bidn).next().next().length > 0;
        if (firstbid) {

            $(bidn).next().next().click();
        }
        else {

            $('.t4s-pr.t4s-lookbook-wrapper').find(">span:first").trigger("click");
        }
    })},10000);
setTimeout(function(){
  if (window.matchMedia('(max-width: 1024px)').matches) {
  $(".template-product .t4s-tabs-accordion-enabled .t4s-tab-wrapper").each(function() {
    $(this).addClass("t4s-active");
    $(this).find(".t4s-tab-content").show();
});
  }
},1000);
//   $(window).load(function () {
//     // Run code
// $('.t4s-cart__agree a').click(function (e) {
//     e.preventDefault();
//     $('.pop-up-mini-cart.t4s-popup.t4s-container-fluid').show();
// });
// });

});
